module.exports = __webpack_public_path__ + "img/tai-chinh-doanh-nghiep.d300e92c.png";